import { Tooltip } from "react-tooltip";
import { cn } from "@/src/helpers";

export default function QuarkleTooltip({
  className,
  place = "top",
  offset = 8,
  delayShow = 350,
  ...props
}) {
  return (
    <Tooltip
      className={cn("qk-tooltip", className)}
      place={place}
      offset={offset}
      delayShow={delayShow}
      {...props}
    />
  );
}
